<div class="row mb-4" [hidden]="field.hidden"  [formGroup]="formGroup!">

    <label class="col-sm-2 col-form-label form-label">
        {{field.label}}
        <span class="text-danger" *ngIf="field.required"> * </span>
    </label>

    <div class="col-sm-10">

        <table
            class="multiple-input-list table table-condensed table-renderer">
            <tbody>
                <tr class="multiple-input-list__item" data-index="0">

                    <td
                        class="list-cell__environmental_exsits_approval_file">

                        <div
                            class="field-dynamicmodel-environmental_exsits_approval_file-0 form-group">

                            
                            <input formControlName="{{fieldId}}"
                                #myInput
                                [ngClass]="isInvalid && submitted ? 'is-invalid':null"
                                [multiple]="field.multiSelect"
                                class="form-control" type="file"
                                [accept]="allowedExtension(field.mediaType!,field.allowedExtensions!)"
                                (change)="onUploadFile(fieldId!,$event,field.multiSelect!,field.mediaType!,field.allowedExtensions!)"
                                [required]="field.required && files.length==0">

                            <p class="pt-1"
                                style="font-size: 13px !important;"
                                *ngIf="field?.description">
                                {{field.description}}
                            </p>

                            <p class="pt-1 text-danger"
                                style="font-size: 13px !important;"
                                *ngIf="yourTurn && field?.approved == false">
                                {{field.comment}}
                            </p>

                            <div
                                *ngIf="field.required && files.length==0 && submitted">
                                <span class="text-danger"  >
                                    {{'requiredField'|translate}}!
                                </span>
                            </div>
                        </div>



                        <table class="table text-center my-3"
                            *ngIf="files.length>0">
                            <thead class="thead-light">
                                <tr>
                                    <th>اسم الملف</th>
                                    <!-- <th  *ngIf="!viewApplication">id</th> -->
                                    <th>الاجراء</th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr
                                    *ngFor="let item of files">
                                    <td>{{field.label}}</td>
                                    <!-- <td style="max-width: 120px;" *ngIf="!viewApplication">{{item.objectId}}</td> -->
                                    <td>

                                        <i role="button" *ngIf="viewApplication && item.fileBase64!=null &&item.fileBase64!=''" (click)="downloadMinioFile(item.fileBase64)" class="fa fa-eye text-primary px-2"></i>
                                        <i role="button" *ngIf="!viewApplication && item.objectId!=null &&item.objectId!=''" (click)="downloadMinioFile(item.objectId)" class="fa fa-eye text-primary px-2"></i>

                                        <i role="button"  *ngIf="!viewApplication && field.editable==true"
                                            (click)="deleteFile(item.id)"
                                            class="fa-solid fa-trash text-danger"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <br>

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>